<template>
  <div
    class="game-content j-game-page"
    ref="gamepage"
    @mouseleave="setRealIconPosition"
  >
    <!-- use in fb canvas pay -->
    <iframe
      :src="fbPayLink"
      class="j-fb-pay-iframe fb-pay-iframe"
      ref="fbPayIframe"
      v-if="isFbCanvas"
    ></iframe>

    <i
      class="move-mask"
      v-show="canDrag"
      @mousemove="updateIconPosition"
      @mouseup="setRealIconPosition"
    ></i>
    <iframe
      :src="gameLink"
      class="iframe j-gamepage-iframe"
      v-if="!!gameLink"
      ref="gameFrame"
    ></iframe>
    <transition name="fade">
      <LoginPopup v-show="!isLogin && isShowLogin && !isDmm"></LoginPopup>
    </transition>

    <AsidePopup
      @closeAsidePopup="closeAsidePopup"
      @updataGamePage="updataGamePage"
      @asideLoaded="asideLoaded"
      :isShowAsidePopup="isShowAsidePopup"
      :openTarget="asideOpenTarget"
      v-if="showAside"
    ></AsidePopup>

    <!-- use in fb canvas pay -->
    <transition name="fade">
      <div v-show="showStoreTip" class="store-popup">
        <i class="close" @click="closeStorePopup"></i>
        <p class="tip">{{ tipsLabel }}</p>
        <a href="javascript:;" class="go" @click="excFbPay">{{ letter.go }}</a>
      </div>
    </transition>
    <transition name="fade">
      <i
        class="mask"
        v-show="
          (!isLogin && !isDmm) || showAsidePopup || showStoreTip || commonFBTips
        "
      ></i>
    </transition>
    <img
      class="float-icon"
      :src="iconHref"
      draggable="false"
      @mouseup="clickFn"
      @mousedown="saveMousePosition"
      ref="floatIcon"
      @touchstart="saveMousePosition"
      @touchmove="updateIconPosition"
      @touchend="clickFn"
      v-show="false"
      ondragstart="return false;"
    />

    <!-- use in web pay -->
    <transition name="fade">
      <store-popup
        :sdk-param="sdkParam"
        @close="showStorePopup = false"
        v-if="showStorePopup"
      ></store-popup>
    </transition>

    <!-- use in fb canvas pay -->
    <transition name="fade">
      <Tips v-show="commonFBTips" :text="commonFBTipsText"></Tips>
    </transition>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import {
  GET_GAME_LINK,
  GET_BASE_INFO,
  ENTER_GAME,
  CREATE_ROLE,
  SAVE_USER_GAME_INFO,
  UPDATE_GAMEID,
  FETCH_PAY_WAY,
  FETCH_LAST_PAY_WAY,
  GET_PRODUCT_INFO,
  GET_DMM_PRODUCT_INFO,
  GET_SERVER_LIST,
  DATAIN_DATA,
  DO_GET_USER_INFO,
  DMM_LOGOUT,
  CHECK_DMM_SIGN
} from '../store/web/h5';
import LoginPopup from '../components/LoginPopup';
import AsidePopup from '../components/AsidePopup';
import h5Sdk, {
  SAVE_LOGIN_TYPE_LOCALSTORAGE,
  ACCOUNT_TYPE,
  UUID
} from '../mixins/h5Sdk.js';
import globalConfig from '../utiles/globalConfig';
import storePopup from './storePopup';
import Tips from './Tips';
import {
  HREF_IS_DMM,
  CHECK_DMM_LOGIN,
  HREF_IS_MOBAGE,
  TRANSACTION_ID,
  H
} from '../store/web/h5';
import { twiShare, lineShare as lShare } from '../utiles/thirdParty';
import mobagePayment from '../mixins/mobage';
let thirdPlatform = {};
let isThirdPlatform = false;
if (HREF_IS_MOBAGE) {
  thirdPlatform = mobagePayment;
  isThirdPlatform = true;
}
export default {
  name: 'h5pc',
  mixins: [h5Sdk, thirdPlatform],
  props: ['isFbCanvas'],
  data() {
    return {
      showAsidePopup: false,
      showStoreTip: false,
      storePageSrc: '',
      isShowLogin: false,
      iconHref: window.icon,
      iconX: 0,
      iconY: 0,
      lastY: 0,
      isDrag: false,
      canDrag: false,
      iframeW: 0,
      iframeH: 0,
      iconW: 0,
      iconH: 0,
      floatIconEle: null,
      asideIsLoad: false,
      showStorePopup: false,
      sdkParam: {},
      fbPayLink:
        window.location.protocol + '//jpstore.37games.com/html/h5FbCanvas.html',
      commonFBTips: false,
      commonFBTipsText: '',
      orderId: '',
      asideOpenTarget: '',
      isDmm: HREF_IS_DMM,
      isMobage: HREF_IS_MOBAGE,
      pid: '',
      widget: null
    };
  },
  watch: {
    isLogin(newV, oldV) {
      if (oldV !== newV) {
        if (newV) {
          this.get_award_state();
          this.$store.dispatch(GET_GAME_LINK);
        } else {
          this.$store.commit('getAwardState', {
            likeAward: false,
            downloadAward: false
          });
        }
      }
    }
  },
  computed: {
    showAside() {
      return !this.isFbCanvas && !this.isMobage && this.isLogin;
    },
    isShowAsidePopup() {
      if (this.showAsidePopup && !this.isLogin) {
        this.showAsidePopup = false;
      }
      return this.showAsidePopup && this.isLogin;
    },
    gameLink() {
      if (
        HREF_IS_DMM &&
        !(sessionStorage.getItem('gameLink1') || this.$store.state.gameLink)
      ) {
        return '';
      }
      if (process.env.NODE_ENV === 'production') {
        if (this.isLogin && window.canPlay) {
          let _url = '';
          if (this.isFbCanvas) {
            _url = `//${window.pageInfo.host_name}.37games.com/index/gamePage?game_id=${this.gameId}&fbcanvas=1&uid=${this.accountId}`;
          } else {
            if (window.location.search) {
              _url = window.location.href.replace(
                /\?/,
                `index\/gamePage\?game_id=${this.gameId}\&uid=${this.accountId}\&`
              );
            } else {
              _url =
                window.location.origin +
                `/index/gamePage?game_id=${this.gameId}&uid=${this.accountId}`;
            }
          }
          return window.globalGetGotoLink({ link: _url });
        } else {
          return '';
        }
      } else {
        if (this.isLogin && window.canPlay) {
          let _url = '';
          if (window.location.search) {
            _url =
              window.location.origin +
              `/h5gamePage.html${window.location.search}&game_id=${this.gameId}&uid=${this.accountId}`;
          } else {
            if (this.isFbCanvas) {
              _url =
                window.location.origin +
                `/h5gamePage.html?game_id=${this.gameId}&fbcanvas=1&uid=${this.accountId}`;
            } else {
              _url =
                window.location.origin +
                `/h5gamePage.html?game_id=${this.gameId}&uid=${this.accountId}`;
            }
          }
          return window.globalGetGotoLink({ link: _url });
        } else {
          return '';
        }
      }
    },
    reserAsidePopup() {
      return !this.isLogin;
    },
    tipsLabel() {
      return this.letter.goStoreTip;
    },
    ...mapGetters([
      'letter',
      'isLogin',
      'gameId',
      'lang',
      'accountName',
      'accountId',
      'serverId'
    ])
  },
  components: {
    LoginPopup,
    AsidePopup,
    storePopup,
    Tips
  },
  beforeCreate() {
    window.onbeforeunload = function() {
      return true;
    };
    this.$store
      .dispatch(UPDATE_GAMEID, parseInt(window.gameId, 10))
      .then(() => {
        this.$store.dispatch(GET_BASE_INFO).then(() => {
          if (this.isFbCanvas) {
            this.fbUpdateUserInfo({
              LOGIN_ACCOUNT: window.loginAccount || '',
              UID: ''
            });
          } else {
            if (
              sessionStorage.getItem('usedDmmlogin') === '1' &&
              !HREF_IS_DMM
            ) {
              this.$store.dispatch(DMM_LOGOUT).then(() => {
                sessionStorage.setItem('usedDmmlogin', '0');
                this.getUserInfo();
              });
            } else {
              this.getUserInfo();
            }
          }
        });
      });
  },
  mounted() {
    // let addEvenListener = window.addEventListener || window.attatchEvent;
    // let messageEvent = window.addEventListener ? "message" : "onmessage";
    // addEvenListener(messageEvent,,false);

    globalConfig.addEvenListener(this.sdkMessageHandler);

    window.onbeforeunload = () => {
      try {
        globalConfig.statistics('click_close_window');
      } catch (e) {}
      return this.letter.leaveTip;
    };
    if (!this.isMobage) {
      this.getStoreWay();
    }
  },
  methods: {
    collectData(data) {
      this.$store.dispatch(DATAIN_DATA, {
        loginAccount: HREF_IS_DMM
          ? localStorage.getItem('currLoginAccount')
          : this.accountId,
        ...data
      });
    },
    getUserInfo() {
      this.$store.dispatch(DO_GET_USER_INFO).then((res) => {
        // 获取页面配置信息
        this.$store.dispatch(GET_BASE_INFO);
        if (HREF_IS_DMM || parseInt(res.result, 10) === 0) {
          // alert(globalConfig.getLclStorageItem(SAVE_LOGIN_TYPE_LOCALSTORAGE));
          this.login();
        }
      });
    },
    // 获取储值渠道
    getStoreWay() {
      this.$store.dispatch(FETCH_PAY_WAY).then((data) => {
        this.$store.dispatch(FETCH_LAST_PAY_WAY);
      });
      this.$store.dispatch(GET_SERVER_LIST);
    },
    // openAsidePopup(e){
    //     if(!this.isDrag){
    //         this.showAsidePopup = true;
    //     }
    // },
    closeAsidePopup() {
      this.showAsidePopup = false;
    },
    updataGamePage() {
      this.$refs.gameFrame.contentWindow.location.reload(true);
    },
    asideLoaded() {
      this.asideIsLoad = true;
      this.$nextTick(() => {
        // 用于浮动icon拖拽
        this.floatIconEle = this.$refs.floatIcon;
        const floatIconRef = this.$refs.floatIcon.getBoundingClientRect();
        const gamePageRef = this.$refs.gamepage.getBoundingClientRect();

        this.iconY = parseInt(floatIconRef.top + floatIconRef.height / 2, 10);
        this.iconX = parseInt(floatIconRef.left + floatIconRef.width / 2, 10);

        this.iconW = parseInt(floatIconRef.width, 10);
        this.iconH = parseInt(floatIconRef.height, 10);

        this.iframeW = parseInt(gamePageRef.width, 10);
        this.iframeH = parseInt(gamePageRef.height, 10);
      });
    },
    sdkMessageHandler(evt) {
      var ev = evt || event;
      let action = ev.data.action;
      if (!!action && !!this[action]) {
        this[action](ev.data.param);
      }
    },

    openUserCenter() {
      if (this.showAside) {
        this.asideOpenTarget = '';
        this.showAsidePopup = true;
      }
      if (isThirdPlatform) {
        this.openThirdPlatformUserCenter &&
          typeof this.openThirdPlatformUserCenter === 'function' &&
          this.openThirdPlatformUserCenter('service');
      }
    },

    openUserCenterToBind() {
      if (this.showAside) {
        this.asideOpenTarget = 'bind';
        this.showAsidePopup = true;
      }
    },
    /*
            进入游戏后的调用，通过js-sdk 传递
        */
    enterGame(sdkParam) {
      this.$store.dispatch(DATAIN_DATA, {
        event: 'click',
        loginAccount: HREF_IS_DMM
          ? localStorage.getItem('currLoginAccount')
          : this.accountId,
        ext1: '进入游戏'
      });
      console.info('enter_server');
      console.info(sdkParam);
      const params = this.formatHrefParam();
      this.$store.dispatch(ENTER_GAME, {
        serverId: sdkParam.serverId,
        otherParam: { ...params, ...sdkParam }
      });
      try {
        globalConfig.statistics('enter_server');
      } catch (e) {}
    },
    /*
            获取到角色信息后的调用，通过js-sdk 传递
        */
    roleInfo(sdkParam) {
      console.info('get_role_info');
      console.info(sdkParam);
      this.$store.dispatch(SAVE_USER_GAME_INFO, sdkParam);

      // this.$store.dispatch(ENTER_GAME, {
      //   game_server_sid: sdkParam.serverId,
      //   otherParam: sdkParam,
      // });

      // this.$refs.gameFrame.contentWindow.gtmCreateRole(
      //   window,
      //   document,
      //   "script",
      //   "dataLayer",
      //   this.$refs.gameFrame.contentWindow.gtmCreateRoleId
      // );
    },
    /*
            创建角色后获取到角色信息后的调用，通过js-sdk 传递
        */
    createRole(sdkParam) {
      console.info('create_role');
      console.info(sdkParam);
      const params = this.formatHrefParam();
      this.$store.dispatch(CREATE_ROLE, {
        serverId: sdkParam.serverId,
        otherParam: { ...params, ...sdkParam }
      });
      try {
        globalConfig.statistics('create_role');
      } catch (e) {}
    },
    /*
            发起储值时调用，通过js-sdk 传递
        */
    pay(sdkParam) {
      console.info('pay');
      console.info(sdkParam);
      this.pid = sdkParam.productId;
      try {
        globalConfig.statistics('pay');
      } catch (e) {}
      if (this.isFbCanvas) {
        this.fbPay(sdkParam);
      } else {
        if (isThirdPlatform) {
          this.thirdPlatformPay(sdkParam);
          return;
        }
        // 如果为dmm模式，储值前需要验证登录;取消加载提示直接加载
        if (HREF_IS_DMM) {
          window.onbeforeunload = false;
          this.$store.dispatch(CHECK_DMM_LOGIN, 1).then(() => {
            this.thirdPartyPay(sdkParam);
          });
        } else {
          this.$store.dispatch(FETCH_LAST_PAY_WAY);
          // 这个加载页面的时候就已经设置了，应该不用重复设置？--影响h5jssdk监控流程
          // window.onbeforeunload = () => {
          //   return this.letter.leaveTip;
          // };
          this.thirdPartyPay(sdkParam);
        }
      }
    },
    gerOrderSuccess(res) {
      console.log(res);
      if (0 == res.result) {
        this.commonFBTips = true;
        this.commonFBTipsText = res.msg;
      } else {
        this.showStoreTip = true;
        this.orderId = res.data.order_id;
      }
    },
    fbPay(sdkParam) {
      document.querySelector('.j-fb-pay-iframe').contentWindow.postMessage(
        {
          info: {
            appId: window.appInfo.APP_ID,
            productId: sdkParam.productId,
            // productId : "150.00",
            paytype: 'facebook_local_money',
            fpaytype: 'facebook_local_money',
            gameId: this.gameId,
            serverId: sdkParam.serverId,
            roleId: sdkParam.roleId,
            roleName: sdkParam.roleName,
            roleLevel: 0,
            loginAccount: encodeURIComponent(this.accountName),
            currency: 'JPY',
            remark: sdkParam.remark || sdkParam.price || '',
            cpOrderID: sdkParam.order_no || ''
          }
        },
        window.location.protocol + '//jpstore.37games.com'
      );
    },
    excFbPay() {
      try {
        globalConfig.statistics('submit_pay', {
          pid: this.pid,
          pay_type: 'facebook_local_money'
        });
      } catch (e) {}
      this.closeStorePopup();
      this.fbSdkPay(window.appInfo.APP_ID, this.orderId).then(
        this.fbPaySucc,
        this.fbPayErr
      );
    },
    twitterShare(param) {
      let txt = param && param.txt ? param.txt : '';
      let href =
        param && param.href
          ? param.href
          : window.pageInfo.twitter_share || window.location.href;
      twiShare(txt, href);
      try {
        globalConfig.statistics('twitter_share');
      } catch (e) {}
    },
    lineShare(href) {
      lShare(href);
      try {
        globalConfig.statistics('line_share');
      } catch (e) {}
    },
    fbPaySucc(res) {
      this.commonFBTips = true;
      this.commonFBTipsText = 'チャージ成功';
    },
    fbPayErr(res) {
      this.commonFBTips = true;
      console.log(res);
      this.commonFBTipsText =
        'チャージ失敗' +
        (!!res
          ? res['error_code'] == 1383010
            ? 'チャージがキャンセルされました！'
            : '案内：' + res['error_message']
          : '');
    },
    thirdPartyPay(sdkParam) {
      // https://jpstore.37games.com/show_paytype?game_id=2&location=JP&language=jp&product_id=beauty.app.gold3600&server_id=150&role_id=150003445&callback=jsonpCallback2
      // console.log('pay');
      // console.log(sdkParam);
      //     this.storePageSrc = [
      //         `//jpstore.37games.com/?`,
      //         `gameId=${this.gameId}`,
      //         `&serverId=${sdkParam.serverId}`,
      //         `&packageName=`,
      //         `&userId=${this.accountId}`,
      //         `&productId=${sdkParam.productId}`,
      //         `&cpProductId=`,
      //         `&devicePlate=${window.isPhone?"wap":"pc"}`,
      //         `&remark=${sdkParam.order_no || ""}`,
      //         `&location=`,
      //         `&loginAccount=${encodeURIComponent(this.accountName)}`,
      //         `&appLanguage=${this.lang}`,
      //         `&roleName=${encodeURIComponent(sdkParam.roleName)}`,
      //         `&roleId=${sdkParam.roleId}`,
      //         `&language=${this.lang}`,
      //         `&web=1`
      //     ].join('');
      // this.showStoreTip = true;
      this.sdkParam = sdkParam;
      this.$store.dispatch(DATAIN_DATA, {
        event: 'open',
        loginAccount: HREF_IS_DMM
          ? localStorage.getItem('currLoginAccount')
          : this.accountId,
        ext1: '打开储值页面'
      });
      const productInfoUrl = HREF_IS_DMM
        ? GET_DMM_PRODUCT_INFO
        : GET_PRODUCT_INFO;
      this.$store
        .dispatch(productInfoUrl, sdkParam)
        .then((res) => {
          this.showStorePopup = true;
        })
        .catch((err) => {
          alert(err);
        });
    },
    closeStorePopup() {
      this.showStoreTip = false;
    },
    // 实时更新icon位置
    updateIconPosition(e) {
      e.preventDefault();
      if (this.canDrag) {
        this.isDrag = true;

        let eventX = parseInt(e.clientX || e.changedTouches[0].clientX, 10);
        let eventY = parseInt(e.clientY || e.changedTouches[0].clientY, 10);

        let moveY = eventY - this.iconY;
        let moveX = eventX - this.iconX;

        let limtParamIcon = this.iconH / 2;
        let limtParamIframe = this.iframeH / 2;

        if (moveX > 0) {
          moveX = 0;
        }
        if (moveX < -1 * this.iframeW + this.iconW) {
          moveX = -1 * this.iframeW + this.iconW;
        }

        if (moveY < -1 * limtParamIframe + limtParamIcon) {
          moveY = -1 * limtParamIframe + limtParamIcon;
        } else if (moveY > limtParamIframe - limtParamIcon) {
          moveY = limtParamIframe - limtParamIcon;
        }

        this.lastY = moveY;
        this.floatIconEle.style.transform = `translateX(${moveX}px) translateY(${moveY}px)`;
      }
    },
    // icon贴边
    setRealIconPosition(e) {
      e.preventDefault();
      if (this.asideIsLoad && this.canDrag) {
        this.canDrag = false;
        this.floatIconEle.style.transform = `translateX(0px) translateY(${this.lastY}px)`;
      }
    },
    saveMousePosition() {
      this.isDrag = false;
      this.canDrag = true;
    },
    clickFn(e) {
      this.setRealIconPosition(e);
      if (!this.isDrag) {
        this.asideOpenTarget = '';
        this.showAsidePopup = true;
      }
    },
    formatHrefParam() {
      let res = {};
      let paramArr = window.location.search.substr(1).split('&');
      paramArr.map((item) => {
        let resStr = item.split('=');
        if (resStr.length > 1) {
          res[resStr[0]] = resStr[1];
        }
      });
      return res;
    },

    // 以下是登录流程

    login() {
      let loginType = globalConfig.getLclStorageItem(
        SAVE_LOGIN_TYPE_LOCALSTORAGE
      );
      if (loginType && !HREF_IS_DMM) {
        try {
          globalConfig.statistics('login_type', {
            login_type: loginType
          });
        } catch (e) {}
        switch (loginType) {
          case ACCOUNT_TYPE.fb:
            this.showLoginTip('fb');
            break;
          case ACCOUNT_TYPE.tw:
            this.showLoginTip('twitter');
            break;
          case ACCOUNT_TYPE.to:
            this.readyTouristLogin().then((res) => {
              if (res.result != '1') {
                alert(res.msg);
              } else {
                window.dataLayer.push({
                  event: 'tourist_register'
                });
              }
            });
            break;
          default:
            this.readyTouristLogin().then((res) => {
              if (res.result != '1') {
                alert(res.msg);
              } else {
                window.dataLayer.push({
                  event: 'tourist_register'
                });
              }
            });
            break;
        }
      } else {
        try {
          globalConfig.statistics('login_type', {
            login_type: ACCOUNT_TYPE.to
          });
        } catch (e) {}
        this.readyTouristLogin().then((res) => {
          if (res.result != '1') {
            alert(res.msg);
            return;
          } else {
            window.dataLayer.push({
              event: 'tourist_register'
            });
          }
        });
      }
    },

    showLoginTip(type) {
      this.isShowLogin = true;
    },
    toggleCommonTips(state) {
      this.commonFBTips = state;
    },
    gameLoad() {
      try {
        globalConfig.statistics('game_load');
      } catch (e) {}
    },
    enter_server(sdkParam) {
      this.$store.dispatch(DATAIN_DATA, {
        event: 'click',
        loginAccount: HREF_IS_DMM
          ? localStorage.getItem('currLoginAccount')
          : this.accountId,
        ext1: '进入游戏'
      });
      console.info('enter_server');

      console.info(sdkParam);
      const params = this.formatHrefParam();
      this.$store.dispatch(ENTER_GAME, {
        serverId: sdkParam.serverId,
        otherParam: { ...params, ...sdkParam }
      });
      try {
        globalConfig.statistics('enter_server');
      } catch (e) {}
    },
    open_pay_list() {
      console.info('open_pay_list');
      try {
        globalConfig.statistics('open_pay_list');
      } catch (e) {}
    },
    enter_main_game() {
      console.info('enter_main_game');
      try {
        globalConfig.statistics('enter_game');
      } catch (e) {}
    },
    enter_select_server_page() {
      console.info('enter_select_server_page');
      try {
        globalConfig.statistics('enter_server_page');
      } catch (e) {}
    },
    enter_create_role_page() {
      console.info('enter_create_role_page');
      try {
        globalConfig.statistics('enter_create_role_page');
      } catch (e) {}
    },
    is_role(param) {
      console.info('is_role');
      console.log(param);
      try {
        globalConfig.statistics('is_role', param);
      } catch (e) {}
    },
    click_create_role_btn() {
      console.info('click_create_role_btn');
      try {
        globalConfig.statistics('click_create_role');
      } catch (e) {}
    },
    click_enter_game_btn() {
      console.info('click_enter_game_btn');
      try {
        globalConfig.statistics('click_enter_game');
      } catch (e) {}
    },
    scroll_top() {
      try {
        document.querySelector('.iframe-box').scrollTo({ top: 0 });
      } catch (e) {}
    },
    user_behave(sdkParam) {
      console.info('user_behave');
      if (
        isThirdPlatform &&
        this.thirdPlatformHandleUserBehave &&
        typeof this.thirdPlatformHandleUserBehave === 'function'
      ) {
        this.thirdPlatformHandleUserBehave(sdkParam);
      }
      // 绕过 上一步/账号记录 流程
      // window.dataLayer.push({
      //   event: "game_user_behave",
      //   is_new: globalConfig.judgeIsNewUser(),
      //   userName: this.userName,
      //   ...sdkParam,
      // });
      if (Object.prototype.toString.call(sdkParam) == '[object Object]') {
        globalConfig.ajaxStatistics(
          sdkParam.eventName,
          sdkParam.eventValue,
          sdkParam.eventType,
          this.accountName,
          this.serverId
        );
      }
      try {
        const { eventType, ...otherParams } = sdkParam;
        globalConfig.statistics(eventType, otherParams);
      } catch (e) {
        console.error(e);
      }
    },
    ...mapActions(['fbUpdateUserInfo', 'get_award_state'])
  }
};
</script>
